import React, { useContext, useEffect } from 'react';
import { Box } from '@mui/material';
import { nanoid } from 'nanoid';
import CreateProcessContext from 'shared/contexts/CreateProcessContext';
import DependentsType from '../inputSections/DependentsType';
import NewEmployeeType from '../inputSections/NewEmployeeType';

const panelStyle = {
  marginTop: '1rem',
  '& > .MuiPaper-root': { marginBottom: '1rem' },
};

const NewIndividual: React.FC = () => {
  const { setProcess } = useContext(CreateProcessContext);

  useEffect(() => {
    // Reset form
    setProcess((draft) => {
      draft.companyID = null;
      draft.employeeData = {
        firstname: '',
        lastname: '',
        email: '',
        tempID: nanoid(),
      };
      draft.employmentData = {};
      draft.foreignNationalID = null;
      draft.individualSponsored = null;
      draft.jobDescriptionID = null;
      draft.requestedProcess = null;
    });
  }, []);

  return (
    <Box sx={panelStyle}>
      <NewEmployeeType />

      <DependentsType />
    </Box>
  );
};

export default NewIndividual;
